import {
  PRODUCTS,
  PRICEBOOKS,
  PIPELINE,
  WORKFLOWS,
  TEMPLATES,
} from "./permissions";

import { FEATURES_NAME } from "./features";

export const GATING_TYPES = {
  FEATURE: "feature",
  ON_BOARD: "onboard",
};

export const NAVITEMS = {
  salesOps: {
    alias: "salesRep",
    text: "Go To SalesRep",
    navItems: [
      // {
      //   name: "PIPELINE",
      //   link: "/pipeline",
      //   readPermission: PIPELINE.READ_DEALS,
      //   ico: "columns",
      //   tooltip: "OPPORTUNITY PIPELINE",
      // },
      {
        name: "ASSETS",
        link: "/assets",
        readPermission: PIPELINE.READ_DEALS,
        ico: "folders",
        tooltip: "Documents",
      },
      {
        name: "TEMPLATES",
        link: "/templates",
        readPermission: TEMPLATES.READ_TEMPLATES,
        ico: "files-medical",
        tooltip: "Templates",
        featureGating: {
          type: GATING_TYPES.ON_BOARD,
          name: "templates",
        },
      },
      {
        name: "KANBAN",
        link: "/pipeline",
        ico: "columns",
        tooltip: "Pipeline",
      },
      // {
      //   name: "DASHBOARD",
      //   link: "/dashboard",
      //   ico: "chart-line",
      //   tooltip: "Dashboard",
      // },
      {
        name: "PRODUCTS",
        link: "/products",
        readPermission: PRODUCTS.READ_PRODUCTS,
        ico: "shapes",
        tooltip: "Products",
        featureGating: {
          type: GATING_TYPES.FEATURE,
          name: "products",
          featureName: FEATURES_NAME.PRODUCT_HIDDEN,
        },
      },
      {
        name: "PRICEBOOKS",
        link: "/pricebooks",
        readPermission: PRICEBOOKS.READ_PRICEBOOKS,
        ico: "book-spells",
        tooltip: "PriceBooks",
        featureGating: {
          type: GATING_TYPES.FEATURE,
          name: "pricebooks",
          featureName: FEATURES_NAME.PRICEBOOK_ADD_PRICEBOOK,
        },
      },

      {
        name: "WORKFLOW",
        link: "/workflow",
        readPermission: WORKFLOWS.READ_WORKFLOWS,
        ico: "network-wired",
        tooltip: "Workflows",
        featureGating: {
          type: GATING_TYPES.FEATURE,
          name: "workflows",
          featureName: FEATURES_NAME.WORKFLOW_CREATE_NEW,
        },
      },
      // {
      //   name: "INBOX",
      //   link: "/inbox",
      //   ico: "inbox-in",
      //   tooltip: "Inbox",
      // },
    ],
  },
};

export const ONBOARD_TEXT = {
  pricebooks: {
    title: "About Price Books",
    subTitle:
      "Watch this video to understand how to add your products in the Price Book before you proceed",
    videoUrl:
      "https://www.youtube.com/embed/YyVKXZb3YUA?utm_source=RevvSales%20app&utm_medium=price%20book%20tab&utm_campaign=pop%20up",
    ico: "book-spells",
    pageName: "Price Books",
    featureDescription:
      "Easily configure and manage complex products and prices using RevvSales Price Books' out of the box functionalities.",
    features: [
      "Multiple pricing options including range, bundles and PoT",
      "Multiple price books and currency support",
      "Spreadsheet like view with search and column sort",
    ],
    btnTxt: "Go to pricebooks",
    link: "/pricebooks",
  },
  products: {
    title: "About Products",
    subTitle:
      "Watch this video to understand how to add your products in the Products catalog before you proceed.",
    videoUrl:
      "https://www.youtube.com/embed/xWxDKoZfNuE?utm_source=RevvSales%20app&utm_medium=Product%20catalog%20tab&utm_campaign=pop%20up",
    ico: "shapes",
    pageName: "Products",
    featureDescription:
      "Manage your entire list of products and services in the product catalog.",
    features: [
      "Robust product configuration options",
      "Product bundle support",
      "Multi level groups and product categorization ",
    ],
    btnTxt: "Go to products",
    link: "/products",
  },
  templates: {
    title: "📢  Know about Revv Templates before you start ",
    subTitle: "",
    videoUrl:
      "https://www.youtube.com/embed/fpHrfTp-amU?utm_source=RevvSales%20app&utm_medium=Templates%20tab&utm_campaign=pop%20up",
    ico: "files-medical",
    pageName: "Templates",
    featureDescription:
      "Author error-free, visually stunning business documents with reusable templates. <b>To create a template,</b> ",
    features: [
      "Add a template from the <b><i>Template library</i></b> to <b><i>My templates</i></b> and customize as needed. Browse from 1000+ vetted, pre-formatted templates. (or)",
      "Upload a .docx in <b><i>My templates</i></b> and create a new template.",
    ],
    btnTxt: "Go to templates",
    link: "/templates",
  },
  workflows: {
    title: "About Workflows",
    subTitle:
      "You clicked on a Pro feature. Upgrade to a paid plan to create Workflows. To see how it works, watch this video",
    videoUrl:
      "https://www.youtube.com/embed/iNvbUrklzCs?utm_source=RevvSales%20app&utm_medium=Workflow%20tab&utm_campaign=pop%20up",
    ico: "network-wired",
    pageName: "Workflows",
    featureDescription:
      "Use approval workflows to set up guardrails so that your team can create winning offers minus the free-wheeling.",
    features: [
      "Workflows for products quantity and term",
      "Workflows for pricing discounting",
      "Sequential, parallel and group level approvals",
    ],
    btnTxt: "Upgrade my plan",
    link: "/settings/billing",
  },
};



// WEBPACK FOOTER //
// ./src/constants/navbar.js